// import React from 'react';
// import Footer from './Footer'; // Ensure Footer.js is in the same directory
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

// const HowToUse = () => {
//   return (
//     <>
//       <section id="how-to-use" className="how-to-use-section m-3">
//         <div className="container">
//           <h1 className="text-center mb-5">
//             Contact Us <FontAwesomeIcon icon={faEnvelope} />
//           </h1>
//           <div className="row">
//             <div className="col-xl-12">
//               <p>If you have any questions or feedback, feel free to get in touch with us through the following channels:</p>
              
//               <h3>General Inquiries</h3>
//               <p>
//                 <strong>Email:</strong> <a href="mailto:support@umamidb.com">support@umamidb.com</a><br />
//                 <strong>Phone:</strong> +1 (555) 123-4567<br />
//                 <strong>Office Hours:</strong> Monday to Friday, 9 AM to 5 PM (UTC)
//               </p>

//               <h3>Technical Support</h3>
//               <p>
//                 Need help with Umami DB? Contact our technical support team:<br />
//                 <strong>Email:</strong> <a href="mailto:techsupport@umamidb.com">techsupport@umamidb.com</a><br />
//                 <strong>Phone:</strong> +1 (555) 987-6543<br />
//                 <strong>Live Chat:</strong> Available 24/7 on our website
//               </p>

//               <h3>Business Inquiries</h3>
//               <p>
//                 For partnerships or media inquiries:<br />
//                 <strong>Email:</strong> <a href="mailto:business@umamidb.com">business@umamidb.com</a>
//               </p>
//             </div>
//           </div>
//         </div>
//       </section>
//       <Footer />
//     </>
//   );
// };

// export default HowToUse;

// import React from 'react';
// import Footer from './Footer';

// const ContactUs = () => {
//   return (
//     <>
//       <section id="contact" className="contact m-3">
//         <div className="container">
//           <h1 className="text-center mb-5">
//             Contact Us <span role="img" aria-label="telephone">☎</span>
//           </h1>
//           <div className="row">
//             <div className="col-md-6">
//               <h2>Dr. Ganesh Bagler</h2>
//               <p>
//                 <strong>Center for Computational Biology</strong><br />
//                 Indraprastha Institute of Information Technology Delhi (IIIT Delhi),<br />
//                 B-205, Academic Block,<br />
//                 Okhla Phase III, Near Govindpuri Metro Station,<br />
//                 New Delhi, India 110020.
//               </p>
//               <p><strong>Email:</strong> <a href="mailto:bagler+FlavorDB@iiitd.ac.in">bagler+FlavorDB@iiitd.ac.in</a></p>
//               <p><strong>Tel:</strong> +91-11-26907-443 (Work)</p>
//             </div>

//             <div className="col-md-6">
//               <iframe
//                 title="IIIT Delhi Location"
//                 src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4413.270469289108!2d77.26821117474161!3d28.545349976431448!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce3b314d02059%3A0x3942f0d7f30a3749!2sIndraprastha%20Institute%20of%20Information%20Technology%2C%20Delhi!5e0!3m2!1sen!2sin!4v1633432520835!5m2!1sen!2sin"
//                 width="100%"
//                 height="300"
//                 style={{ border: 0 }}
//                 allowFullScreen=""
//                 loading="lazy"
//               ></iframe>
//             </div>
//           </div>
//         </div>
//       </section>
//       <Footer />
//     </>
//   );
// };

// export default ContactUs;

import React from 'react';
import Footer from './Footer';

const ContactUs = () => {
  return (
    <>
      {/* Contact Us Section */}
      <section id="contact" className="contact m-3">
      {/* <h1 className="mb-5 text-center">Contact Us <FontAwesomeIcon icon={faEnvelope} /></h1> */}
        <div className="container">
          <div className="jumbotron">
            <div className="row">
              <div className="col-md-5">
              <h2 className="mb-5">Contact Us 📩</h2>
                <p>
                  Dr. Ganesh Bagler<br />
                  <a href="http://ccb.iiitd.ac.in/">Department of Computational Biology</a><br />
                  Indraprastha Institute of Information Technology Delhi (IIIT Delhi),<br />
                  B-205, Academic Block,<br />
                  Okhla Phase III, Near Govindpuri Metro Station,<br />
                  New Delhi, India 110020.<br />
                  <strong>Email: </strong><a href="mailto:bagler+UmamiDB@iiitd.ac.in">bagler+UmamiDB@iiitd.ac.in</a><br />
                  <strong>Tel:</strong> +91-11-26907-443 (Work)
                </p>
              </div>
              <div className="col-md-7">
                <iframe
                  style={{ minHeight: '500px', width: '100%' }}
                  frameBorder="0"
                  src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJHazaZOXjDDkRVsV7DjQuWCw&key=AIzaSyBRBQG98E5YdUoooyAk2wd-_olpWmL5ACE"
                  allowFullScreen
                  title="IIIT Delhi Location"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </>
  );
};

export default ContactUs;